import axios from "@/util/axios";

export default {
    /**查询消息列表*/
    myWarnMessageList: (data)=> axios.get({url: "/basedata/common/message/myWarnMessageList", data: data}),
    /**读取消息，将消息设置为已读*/
    readWarnMessage: (data)=> axios.post({url: "/basedata/common/message/readWarnMessage", data: data}),
    /**删除消息*/
    deleteWarnMessage: (data)=> axios.post({url: "/basedata/common/message/deleteWarnMessage", data: data}),


}